import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface VenueConfigurationState {
    isGolfEnabled: boolean;
    isBaysEnabled: boolean;
    activeSettingsMode: 'golf' | 'bays';
    toggleGolf: (enabled: boolean) => void;
    toggleBays: (enabled: boolean) => void;
    setActiveSettingsMode: (mode: 'golf' | 'bays') => void;
}

export const useVenueConfigurationStore = create<VenueConfigurationState>()(
    persist(
        (set) => ({
            isGolfEnabled: true, // Default to true for now, can be synced with backend later
            isBaysEnabled: true, // Default to true
            activeSettingsMode: 'bays',
            toggleGolf: (enabled) => set({ isGolfEnabled: enabled }),
            toggleBays: (enabled) => set({ isBaysEnabled: enabled }),
            setActiveSettingsMode: (mode) => set({ activeSettingsMode: mode }),
        }),
        {
            name: 'venue-configuration-storage', // unique name
        }
    )
);
